@if (company()) {
  <mat-toolbar class="header">
    <app-search-field [formControl]="searchControl" />

    <div class="buttons">
      @if (canCopySettings()) {
        <app-button
          variant="stroked"
          color="neutral"
          (click)="openCopySettingsDialog()">
          <mat-icon>content_copy</mat-icon>
          Copy settings
        </app-button>
      }

      @if (!company()?.is_sso_used) {
        <app-button (click)="openDialogInviteUser()">
          <mat-icon>add</mat-icon>
          Invite new member
        </app-button>
      }
    </div>
  </mat-toolbar>
}

<div
  class="table-container"
  saveHeight
  [bottomOffset]="48">
  <div class="table">
    <table
      cdk-table
      appTable
      [dataSource]="dataSource()"
      appSort
      [(sort)]="sort">
      @for (col of displayedColumns(); track col) {
        <ng-container [cdkColumnDef]="col">
          <th
            cdk-header-cell
            appSortHeader
            [sortDisabled]="col === 'actions'"
            *cdkHeaderCellDef>
            {{ tableHeaderList[col] }}
          </th>
          <td
            cdk-cell
            class="{{ col }} {{ col === 'status' ? row[col].status : '' }}"
            *cdkCellDef="let row">
            @switch (col) {
              @case ('first_name') {
                <div class="name-row">
                  @if (!company()?.is_sso_used) {
                    <button
                      type="button"
                      class="cell-link"
                      (click)="openDialogInviteUser(row)">
                      {{ row | fullName }}
                    </button>
                  } @else {
                    <span>{{ row | fullName }}</span>
                  }
                  @if (row.sql_query_access) {
                    @let sqlAccess = row.sql_write_access ? 'SQL write access' : 'SQL access';
                    <span
                      class="sql-chip"
                      [class.token]="row.has_sql_query_token"
                      [appTooltip]="sqlAccess + (row.has_sql_query_token ? ' · token issued' : ' · no token')">
                      {{ row.sql_write_access ? 'SQL RW' : 'SQL' }}
                    </span>
                  }
                </div>
                <p class="email">{{ row.email }}</p>
              }
              @case ('role') {
                {{ row[col].name || '-' }}
              }
              @case ('status') {
                {{ row[col].status || '-' }}
              }
              @case ('created_at') {
                {{ row[col] | customDateFormat: 'dd.MM.yyyy, HH:mm:ss' }}
              }
              @case ('last_sign_in_at') {
                {{ row[col] | customDateFormat: 'dd.MM.yyyy, HH:mm:ss' }}
              }
              @case ('actions') {
                <ng-container *ngTemplateOutlet="actions; context: $any({ col, row })"></ng-container>
              }
              @default {
                {{ row[col] }}
              }
            }
          </td>
        </ng-container>
      }

      <tr *cdkNoDataRow>
        <td [attr.colspan]="displayedColumns().length">
          @if (isLoaded()) {
            <app-table-empty
              message="No users"
              [filtered]="isFiltered()" />
          }
        </td>
      </tr>

      <tr
        cdk-header-row
        *cdkHeaderRowDef="displayedColumns()"></tr>
      <tr
        cdk-row
        *cdkRowDef="let row; columns: displayedColumns()"></tr>
    </table>
  </div>
</div>
<app-paginator
  [length]="length()"
  [pageIndex]="pagination().pageIndex"
  [pageSize]="pagination().pageSize"
  [pageSizeOptions]="[5, 10, 25]"
  (page)="pagination.set($event)" />

<ng-template
  #actions
  let-col="col"
  let-row="row">
  <div class="action-buttons">
    @if (row.invitation_url) {
      <app-button
        ariaLabel="Copy invitation link"
        class="icon"
        color="info"
        [cdkCopyToClipboard]="row.invitation_url">
        <mat-icon>content_copy</mat-icon>
      </app-button>
    }

    <app-button
      ariaLabel="Edit user"
      class="icon"
      (click)="openDialogInviteUser(row)">
      <mat-icon>create</mat-icon>
    </app-button>

    @if (row.status.status === 'active') {
      <app-button
        ariaLabel="Reset password"
        class="icon"
        color="warning"
        (click)="showConfirmResetModal(row)">
        <mat-icon>lock_reset</mat-icon>
      </app-button>
    }

    @if (row.status.status !== 'suspended') {
      <app-button
        ariaLabel="Block user"
        class="icon"
        color="warn"
        (click)="suspendUser(row, 'block')">
        <mat-icon>block</mat-icon>
      </app-button>
    }

    @if (row.status.status === 'suspended') {
      <app-button
        ariaLabel="Unblock user"
        class="icon"
        color="success"
        (click)="suspendUser(row, 'unblock')">
        <mat-icon>lock_open</mat-icon>
      </app-button>
    }
  </div>
</ng-template>
